<div class="tab-pane" id="energyMeter">
    <div class="content_view">
        <div class="widgetList">
            <!-- <div class="widgetList">
            <div class="widget-item">3-Phase Load Current</div>
            <div class="widget-item">3-Phase Line Voltage</div>
            <div class="widget-item">Power Factor</div>
            <div class="widget-item">Frequency</div>
            <div class="widget-item">Total Harmonic Distortion</div>
            <div class="widget-item">Cumulative Energy (KWH)</div>
            <div class="widget-item">Peak Demand (KW)</div>
            <div class="widget-item">Peak Demand (KVA)</div> -->
        </div>
    </div>
</div>
<div class="transformerList">
    <!-- Good Stage -->
    <div class="transformerSingle goodHealth" *ngFor="let energymeterData of energymeterListings">
      <div class="transformerNameIcon">
          <div class="data">
            <h4 class="name bl_color" (click)="energyMeterDashboard(energymeterData.generic_asset_id)" style="cursor: pointer;">{{energymeterData.name}}<!--energy-meter 01--></h4>

            <p class="num"> {{energymeterData.mac_address}}<!--ELM-001-->
            </p>
              <div class="transformerStatus">
                <img src="assets/images/green.png" />
              </div>
          </div>

          <div class="cont-grid">

            <div class="grid-container">

              <div class="grid-item">
                <div class="inside-first-row">

                  <div class="title-meter">Actual Cost:</div>
                  <div class="first-row-data">$105678</div><!-- data value  will go here -->
                </div>
              </div>

              <div class="grid-item">
                <div class="inside-first-row">

                  <div class="title-meter">Actual CO2:</div>
                  <div class="first-row-data">$896674</div><!-- data value  will go here -->
                </div>
              </div>

              <div class="grid-item">
                <div class="inside-first-row">

                  <div class="title-meter">Actual Peak Demand:</div>
                  <div class="first-row-data">$344468</div><!-- data value  will go here  -->
                </div>
              </div>

              <div class="grid-item">
                <div class="inside-first-row">

                  <div class="title-meter">Overall Power Factor:</div>
                  <div class="first-row-data">$432677</div><!-- data value  will go here otal  -->
                </div>
              </div>
            </div>
          </div>        
      </div>
  </div>
